import { useAuth } from '@/lib/useAuth';

/**
 * Whether a product module is switched on for this workspace (from /me).
 *
 * UI only: the API enforces the same flag on every route of the module, so a
 * hidden menu item is a courtesy, never the control (CLAUDE.md §5).
 */
export function useFeature(name: string): boolean {
  const { identity } = useAuth();
  return identity?.features?.[name] === true;
}
